import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

type TableRowTypeMap = BaseTypeMap<'tr'>;

export type TableRowProps = ComponentProps<TableRowTypeMap>;

export const TableRow: Component<TableRowTypeMap> = forwardRef(
  function TableRow({ children, className, ...rest }, ref) {
    return (
      <Box className={cx(className)} ref={ref} {...rest} as="tr">
        {children}
      </Box>
    );
  }
);
